(() => {
	let grid = document.querySelector('[data-grid-scroll]');
	if (!grid) {
		return;
	}
	const containerSelector  = '.event-grid__container';
	const rowSelector        = '.event-grid__row';
	const rowClassActive     = 'event-grid__row--active';
	const rowClassUnloading  = 'event-grid__row--unloading';
	const prevButtonSelector = '.event-grid__button--prev';
	const nextButtonSelector = '.event-grid__button--next';
	const buttonClassActive  = 'event-grid__button--active';
	const transitionDuration = 500;
	let container            = grid.querySelector(containerSelector);
	let prevButton           = grid.querySelector(prevButtonSelector);
	let nextButton           = grid.querySelector(nextButtonSelector);
	if (!container || container.querySelectorAll(rowSelector).length <= 1) {
		return;
	}
	let slideNext = function () {
		if (this.classList.contains(buttonClassActive)) {
			return;
		}
		let button = this;
		let row    = container.querySelector(rowSelector);
		let next   = row.nextElementSibling;
		let clone  = row.cloneNode(true);
		button.classList.add(buttonClassActive);
		row.classList.add(rowClassUnloading);
		next.classList.add(rowClassActive);
		clone.classList.remove(rowClassActive);
		container.appendChild(clone);
		setTimeout(() => {
			button.classList.remove(buttonClassActive);
			container.removeChild(row);
		}, transitionDuration);
	};
	let slidePrev = function () {
		if (this.classList.contains(buttonClassActive)) {
			return;
		}
		let button = this;
		let rows   = container.querySelectorAll(rowSelector);
		let row    = rows[0];
		let next   = rows[rows.length - 1];
		let clone  = next.cloneNode(true);
		clone.classList.add(rowClassActive, rowClassUnloading);
		container.insertBefore(clone, row);
		setTimeout(() => {
			button.classList.add(buttonClassActive);
			container.removeChild(next);
			row.classList.remove(rowClassActive);
			clone.classList.remove(rowClassUnloading);
			setTimeout(() => {
				button.classList.remove(buttonClassActive);
			}, transitionDuration);
		}, 1);
	};
	if (prevButton) {
		prevButton.addEventListener('click', slidePrev);
	}
	if (nextButton) {
		nextButton.addEventListener('click', slideNext);
	}
})();